import parseDialogue from "../../util/parseDialogue";

export const SuperphreakQ1Win = parseDialogue(`
superphreak:q1:100-600

#100 Awesome job! That's how it's done!
>200 Thanks.

#200 You stood up for S.M.A.R.T when everything was on the line and saved the net from completely shutdown, at least for now. I'd say that makes you an elite agent.
>300 You're not so bad yourself.

#300 Disarray was so arrogant that he never disguised his upload location. Once Nightfall was destroyed we traced his signal back to his home. S.M.A.R.T agents are on their way right now to apprehend him.
>400 What a loser.

#400 It turns out he was working on this plan for years. All the time Disarray was a S.M.A.R.T agent, he was really just casing the network in preparation for his master plan. But that's all over now.
>500 So, what now?

#500 Well, until S.M.A.R.T has another crisis to solve, take a break. You earned it. Kick back, relax, play some video games. :) CUL8R.
>600 Who has time for games? ;)
`);
